<template>
  <div v-if="isAdmin" class="obra-admin-controls" aria-label="Controles administrativos">
    <AgeRatingPickerModal :value="ageRatingIds" :ageRatings="ageRatings" @input="$emit('age-rating-picked', $event)" />
    <v-btn icon class="obra-admin-controls__delete" color="red" aria-label="Excluir obra" title="Excluir Obra (Admin)" @click="$emit('delete-project')">
      <v-icon color="red">mdi-delete-forever</v-icon>
    </v-btn>
  </div>
</template>

<script>
import AgeRatingPickerModal from '@/components/AgeRatingPickerModal.vue';

export default {
  name: 'ObraAdminControls',
  components: { AgeRatingPickerModal },
  props: {
    isAdmin: { type: Boolean, default: false },
    ageRatingIds: { type: Array, default: () => [] },
    ageRatings: { type: Array, default: () => [] },
  },
};
</script>
